import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/calendario' };
/////////////////////////////////////////////////////////////////////////////////

export function getCalendario(idPropriedade, data) {
  return httpService.post({ ...args, args: `/${idPropriedade}` }, data);
}
